export default "__VITE_ASSET__DmEhi_$3__"